var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramId64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./ID64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "ID",
    transform: "translate(4.000000, 14.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "device",
    stroke: "#4F4D4C",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 56,
    height: 36,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3.5 C0,1.56700338 1.57095441,0 3.5030508,0 L52.4969492,0 C54.4316307,0 56,1.57093664 56,3.5 L56,7 L0,7 L0,3.5 Z",
    id: "device",
    stroke: "#4F4D4C",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Acocunt",
    transform: "translate(35.000000, 13.663043)",
    stroke: "#4F4C4D",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-6",
    cx: 7,
    cy: 4.33695652,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,15.3369565 C14,11.4709633 10.8659932,8.33695652 7,8.33695652 C3.13400675,8.33695652 0,11.4709633 0,15.3369565",
    id: "Oval-6-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Details",
    transform: "translate(7.800000, 15.869565)",
    stroke: "#4F4D4C",
    strokeDasharray: 0.4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.2,13.1304348 L19.2,13.1304348",
    id: "Bottom"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2,7.13043478 L19.2,7.13043478",
    id: "Middle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2,1.13043478 L10.2,1.13043478",
    id: "Top"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramId64);
export default __webpack_public_path__ + "static/media/pictogramID64.253229dd170b42c9fca4cbb60c2e848f.svg";
export { ForwardRef as ReactComponent };